export default __webpack_public_path__ + "static/media/018-bucket.bbe00468.png";